import styled from 'styled-components'
import { hFlex, overlay, vFlex } from '../../../Styles/style-helpers'

export const ShareModalEl = styled.div`
  ${overlay}
  position: fixed;
  ${vFlex}
  z-index: 100000000;
  background: rgba(0, 0, 0, 0.5);

  .modalContent {
    min-width: 40%;
    background: #fff;
    padding: 1em;
    border-radius: 10px;

    .header {
      ${hFlex}
      padding: 0 0.5em 0.5em;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      justify-content: space-between;

      span {
        cursor: pointer;
      }
    }
    .social {
      ${hFlex}
      padding: 1em 0.5em;

      .share-btn > button > div {
        ${hFlex}
        justify-content: space-between;
        background: white;
        margin: 0 1em;
        color: rgba(0, 0, 0, 0.8);
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        padding: 0.3em 0.6em;
        > svg {
          margin-right: 0.5em;
        }
      }
    }

    .copy-url {
      .heading {
        font-weight: bold;
        margin: 0.5em 0;
      }
      .url {
        ${hFlex}
        p {
          border: 1px solid black;
          border-right: 0;
          text-wrap: clip;
          overflow: hidden;
          white-space: nowrap;
          padding: 0.5em;
        }
      }
    }
  }
`
